module.exports = "<p>\n  payroll-sanction-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/payroll-sanction/payroll-sanction-form/payroll-sanction-form.component.html
// module id = ./src/app/hrms/payroll/payroll-sanction/payroll-sanction-form/payroll-sanction-form.component.html
// module chunks = main